export default function toTitleCase(str) {
  // prettier-ignore
  const lowerCaseList = ['a', 'an', 'and', 'as', 'at', 'for', 'into', 'in', 'is', 'it', 'of', 'on', 'or', 'the', 'to', 'with']
  return str.replace(/\w\S*/g, function (txt) {
    return str.indexOf(txt) !== 0 && lowerCaseList.includes(txt.toLowerCase())
      ? txt.toLowerCase()
      : txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
  })
}
